import { and, isMultiLineControl, isStringControl, rankWith } from "@jsonforms/core";

export default rankWith(4, and(isStringControl, isMultiLineControl));
